export default "assets/images/icons/C&A-white-c898876b.svg";